var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vx-card',{staticClass:"mb-6"},[_c('FiltroTabela',{on:{"filtro":_vm.makeFiltro}})],1),_c('vx-card',[_c('ListTabelas',{attrs:{"filtro":_vm.filtro,"realizaFiltro":_vm.realizaFiltro,"subjectPermission":_vm.subjectPermission},on:{"filtroOk":_vm.finalizaFiltro}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }